var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "properties-field",
      class: { "properties-field-group": _vm.onTable },
      attrs: { id: _vm.id }
    },
    [
      _c("div", { staticClass: "wrap-properties" }, [
        _c("div", { staticClass: "properties-field-title" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-properties",
              on: { click: _vm.closeConfiguration }
            },
            [_vm._v("\n        ×\n      ")]
          ),
          _vm._v(" "),
          _vm._m(1)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "properties-field-content" }, [
          _c(
            "div",
            { staticClass: "section-field input-field" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form",
                        {
                          class: { "error-input": _vm.$v.dataSetup.key.$error }
                        },
                        [
                          _c("div", { staticClass: "title-field" }, [
                            _c("label", [_vm._v(" Key ")])
                          ]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: { placeholder: "Enter button key" },
                            model: {
                              value: _vm.dataSetup.key,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "key", $$v)
                              },
                              expression: "dataSetup.key"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form",
                        {
                          class: {
                            "error-input": _vm.$v.dataSetup.label.$error
                          }
                        },
                        [
                          _c("div", { staticClass: "title-field" }, [
                            _c("label", [_vm._v(" Label ")])
                          ]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: { placeholder: "Enter button label" },
                            model: {
                              value: _vm.dataSetup.label,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "label", $$v)
                              },
                              expression: "dataSetup.label"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.onTable
                ? _c(
                    "div",
                    {
                      staticClass: "icon-configuration",
                      class: { "error-input": _vm.$v.dataSetup.icon_web.$error }
                    },
                    [
                      _c("p", { staticClass: "title" }, [_vm._v("Icon")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "desc" }, [
                        _vm._v("Image that represents the action button.")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "wrap-icon" }, [
                        _c("div", { staticClass: "div-icon" }, [
                          _vm.dataSetup.icon_web
                            ? _c("i", {
                                class:
                                  "fa " +
                                  (_vm.dataSetup.icon_web.includes("fa-")
                                    ? _vm.dataSetup.icon_web
                                    : "fa-" + _vm.dataSetup.icon_web)
                              })
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ml-2" }, [
                          _c("p", { staticClass: "icon-name" }, [
                            _vm._v(_vm._s(_vm.dataSetup.icon_web || "None"))
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "icon-change",
                              on: { click: _vm.openModalIcon }
                            },
                            [_vm._v("\n                Change\n              ")]
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section-field input-field" },
            [
              _c("h4", { staticClass: "title-section" }, [
                _vm._v("Custom Actions")
              ]),
              _vm._v(" "),
              _vm.onTable
                ? _c(
                    "b-row",
                    { staticClass: "m__b--15" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("j-color-picker", {
                            attrs: {
                              color: _vm.dataSetup.font_color,
                              label: "Font Color",
                              picker: "chrome"
                            },
                            model: {
                              value: _vm.dataSetup.font_color,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "font_color", $$v)
                              },
                              expression: "dataSetup.font_color"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("j-color-picker", {
                            attrs: {
                              color: _vm.dataSetup.background_color,
                              label: "Background Color",
                              picker: "chrome"
                            },
                            model: {
                              value: _vm.dataSetup.background_color,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "background_color", $$v)
                              },
                              expression: "dataSetup.background_color"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "configuration-section" }, [
                _c("div", { staticClass: "div-custom-action" }, [
                  _c("div", { staticClass: "wrap-left" }, [
                    _c("img", {
                      staticClass: "icon",
                      attrs: {
                        src: require("@/assets/new-form-ui/icon/script-action.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "title-div" }, [
                        _vm._v(
                          "\n                  Action\n                  "
                        ),
                        _vm.dataSetup.script ||
                        _vm.dataSetup.variable_message ||
                        _vm.dataSetup.variable_redirect
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/new-form-ui/icon-active/check-circle-active.svg")
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "desc-div" }, [
                        _vm._v(
                          "\n                  Actions to be executed overall logic on script\n                "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "open-modal",
                    attrs: { src: require("@/assets/new-form-ui/setup.svg") },
                    on: { click: _vm.openModalScript }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm.dataSetup.container_params || _vm.dataSetup.container_record
                ? _c(
                    "div",
                    { staticClass: "configuration-section" },
                    [
                      _c(
                        "p",
                        { staticClass: "configuration-section-title mb-2" },
                        [_vm._v("Other Variable")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          !_vm.onTable
                            ? _c(
                                "b-col",
                                { staticClass: "mb-2", attrs: { cols: "12" } },
                                [
                                  _c("div", { staticClass: "title-field" }, [
                                    _c("label", [_vm._v(" Variable Params ")])
                                  ]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      "error-required": false,
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.dataSetup.container_params,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "container_params",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.container_params"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("div", { staticClass: "title-field" }, [
                                _c("label", [_vm._v(" Variable Record ")])
                              ]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  "error-required": false,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.dataSetup.container_record,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "container_record",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.container_record"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "section-field input-field" }, [
            _c("h4", { staticClass: "title-section" }, [
              _vm._v("Visibility Condition")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "configuration-section" },
              [
                _c("div", { staticClass: "configuration-toggle-in-title" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "filter-option" }, [
                    _c("div", { staticClass: "filter-selected" }, [
                      _vm._v(_vm._s(_vm.selectedOperator))
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-chevron-down",
                      on: {
                        click: function($event) {
                          _vm.showConditionOptions = true
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.showConditionOptions
                      ? _c("div", { staticClass: "filter-options" }, [
                          _c("p", [_vm._v("Operator")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-around"
                            },
                            _vm._l(_vm.conditionOperatorOptions, function(
                              operator
                            ) {
                              return _c(
                                "div",
                                {
                                  key: operator.id,
                                  staticClass: "operator-option",
                                  class: {
                                    "operator-selected":
                                      operator.id === _vm.selectedOperator
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.closeConditionOptions(operator.id)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(operator.name) +
                                      "\n                  "
                                  )
                                ]
                              )
                            })
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "configuration-section-subtitle" }, [
                  _vm._v("By Value")
                ]),
                _vm._v(" "),
                _vm._l(_vm.conditionByValue, function(data, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "div-filter" },
                    [
                      _c("div", { staticClass: "header-filter" }, [
                        _c("div", { staticClass: "index" }, [
                          _vm._v(_vm._s(index + 1))
                        ]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-trash",
                          on: {
                            click: function($event) {
                              _vm.deleteConditionValue(index)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          staticClass: "mb-2",
                          class: {
                            "error-input":
                              _vm.$v.conditionByValue.$each[index].$invalid &&
                              !data.key
                          }
                        },
                        [
                          _c("label", [_vm._v(" Column ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              "error-required": false,
                              options: _vm.variableOptions,
                              placeholder: "Select Column",
                              "value-format": "object",
                              label: "label"
                            },
                            model: {
                              value: data.key,
                              callback: function($$v) {
                                _vm.$set(data, "key", $$v)
                              },
                              expression: "data.key"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          class: {
                            "error-input":
                              _vm.$v.conditionByValue.$each[index].$invalid &&
                              !data.value
                          }
                        },
                        [
                          _c("label", [_vm._v(" Value ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required": false,
                              placeholder: "Input Condition Value"
                            },
                            model: {
                              value: data.value,
                              callback: function($$v) {
                                _vm.$set(data, "value", $$v)
                              },
                              expression: "data.value"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-add-config",
                    on: { click: _vm.addConditionValue }
                  },
                  [_vm._v("\n            + Add Parameter\n          ")]
                ),
                _vm._v(" "),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.onTable,
                      expression: "!onTable"
                    }
                  ],
                  staticClass: "separator"
                }),
                _vm._v(" "),
                _c(
                  "h3",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.onTable,
                        expression: "!onTable"
                      }
                    ],
                    staticClass: "configuration-section-subtitle"
                  },
                  [_vm._v("By Function")]
                ),
                _vm._v(" "),
                _vm._l(_vm.conditionByFunction, function(data, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.onTable,
                          expression: "!onTable"
                        }
                      ],
                      key: index,
                      staticClass: "div-filter"
                    },
                    [
                      _c("div", { staticClass: "header-filter" }, [
                        _c("div", { staticClass: "index" }, [
                          _vm._v(_vm._s(index + 1))
                        ]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-trash",
                          on: {
                            click: function($event) {
                              _vm.deleteConditionFunction(index)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          staticClass: "mb-2",
                          class: {
                            "error-input":
                              _vm.$v.conditionByFunction.$each[index]
                                .$invalid && !data.key
                          }
                        },
                        [
                          _c("label", [_vm._v(" Column ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              "error-required": false,
                              options: _vm.variableOptions,
                              placeholder: "Select Column",
                              "value-format": "object",
                              label: "label"
                            },
                            model: {
                              value: data.key,
                              callback: function($$v) {
                                _vm.$set(data, "key", $$v)
                              },
                              expression: "data.key"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          class: {
                            "error-input":
                              _vm.$v.conditionByFunction.$each[index]
                                .$invalid && !data.value
                          }
                        },
                        [
                          _c("label", [_vm._v(" Function ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              "error-required": false,
                              options: _vm.functionOptions,
                              placeholder: "Select Function",
                              label: "name"
                            },
                            model: {
                              value: data.value,
                              callback: function($$v) {
                                _vm.$set(data, "value", $$v)
                              },
                              expression: "data.value"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.onTable,
                        expression: "!onTable"
                      }
                    ],
                    staticClass: "btn-add-config",
                    on: { click: _vm.addConditionFunction }
                  },
                  [_vm._v("\n            + Add Parameter\n          ")]
                )
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "properties-field-button" }, [
          !_vm.fieldDetail
            ? _c(
                "button",
                {
                  staticClass: "button-border",
                  on: { click: _vm.resetConfiguration }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/new-form-ui/icon/reset.svg")
                    }
                  }),
                  _vm._v("\n        Reset\n      ")
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "button-border",
                  on: { click: _vm.deleteActionButton }
                },
                [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(" Delete\n      ")
                ]
              ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c(
              "button",
              {
                staticClass: "button-border mr-2",
                on: { click: _vm.closeConfiguration }
              },
              [_vm._v("\n          Close\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "button-blue", on: { click: _vm.submitForm } },
              [_vm._v("\n          Apply\n        ")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "title" }, [
      _vm._v("\n        Properties\n        "),
      _c("div", { staticClass: "title-badge" }, [_vm._v("Button")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-type" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/new-form-ui/icon/button.svg"),
          height: "32"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-type" }, [_vm._v("Action Button")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Condition")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Show action button according to the conditions\n              "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03b846bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b846bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/configuration/ActionButtonConfiguration.vue
// module id = null
// module chunks = 